import React from 'react'
import {OcGenericDialogState} from './OcGenericEditState'
import {useDefinedContextValue} from '@oc/hooks'

const OcGenericDialogStateContext = React.createContext<OcGenericDialogState<any> | null>(null)

export function useOcGenericDialogStateContext<SourceType>() {
    return useDefinedContextValue(
        OcGenericDialogStateContext,
        'OcGenericDialogStateContext'
    ) as OcGenericDialogState<SourceType>
}

interface OcGenericDialogStateContextProps {
    children?: React.ReactNode
}

export function OcGenericDialogStateContextProvider<SourceType>({children}: OcGenericDialogStateContextProps) {
    const [state] = React.useState(() => new OcGenericDialogState<SourceType>([], undefined, ...([] as SourceType[])))

    return <OcGenericDialogStateContext.Provider value={state}>{children}</OcGenericDialogStateContext.Provider>
}
export default OcGenericDialogStateContextProvider
